import { render, staticRenderFns } from "./Santaclaus.vue?vue&type=template&id=6f080e78&scoped=true&"
import script from "./Santaclaus.vue?vue&type=script&lang=js&"
export * from "./Santaclaus.vue?vue&type=script&lang=js&"
import style0 from "./Santaclaus.vue?vue&type=style&index=0&id=6f080e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f080e78",
  null
  
)

export default component.exports